import { render, staticRenderFns } from "./EntriesSync.vue?vue&type=template&id=e227d5fc&scoped=true"
import script from "./EntriesSync.vue?vue&type=script&lang=js"
export * from "./EntriesSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e227d5fc",
  null
  
)

export default component.exports